import { ChangeDetectionStrategy, Component, effect, inject, signal } from '@angular/core'
import { Router } from '@angular/router'
import { MenuService } from '@ui-core/services/menu.service'
import { MobileService } from '@ui-core/services/mobile.service'
import { RouteService } from '@ui-core/services/route.service'
import { MenuItem } from 'primeng/api'
import { ButtonModule } from 'primeng/button'

@Component({
    selector: 'app-side-menu',
    imports: [ButtonModule],
    templateUrl: './side-menu.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SideMenu {
    private menuService = inject(MenuService)
    private mobileService = inject(MobileService)
    private router = inject(Router)
    private routeService = inject(RouteService)

    menu = signal<MenuItem[]>([])
    menuActive = signal('')

    constructor() {
        effect(() => {
            const menu = this.menuService.get()()
            if (menu !== null && menu.length > 0) {
                this.menu.set(menu)
            }
        })

        effect(() => {
            const currentRoute = this.routeService.getCurrentRoute()().replace(/^\//, '')
            if (currentRoute !== '') {
                this.menuActive.set(currentRoute)
            }
        })
    }

    closeMenu(): void {
        this.mobileService.setIsMobileMenuOpen(false)
    }

    goTo(url: string): void {
        this.router.navigate([url])
    }
}
